import { ellipsis } from "@/common/style/commonStyle";
import { MEDIA_QUERIES } from "@/hooks/responsive";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		minWidth: "10rem",
		maxWidth: "30rem",
		width: "25rem",
		padding: `${tokens.spacingVerticalL} 16px`,

		[`@media ${MEDIA_QUERIES.isMobileMediumToSmall}`]: {
			width: "22rem",
		},
	},
	title: {
		fontSize: tokens.fontSizeBase200,
		fontWeight: tokens.fontWeightSemibold,
		marginBottom: "8px",
	},
	transferType: {
		marginLeft: "-8px",
		marginBottom: "10px",
		[`@media ${MEDIA_QUERIES.isMobileMediumToSmall}`]: {
			flexWrap: "wrap",
		},
	},
	transferTargetInput: {
		backgroundColor: tokens.colorNeutralBackground4,
	},
	transferTargetComboBox: {
		marginBottom: "16px",
	},
	routeCallTargetInput: {
		marginBottom: "16px",
	},
	transferTargetField: {
		marginBottom: "16px",
	},
	transferTargetOption: {
		...ellipsis(),
	},
	listItem: {
		backgroundColor: tokens.colorTransparentBackground,
		"& span:nth-child(1)": {
			fontWeight: tokens.fontWeightSemibold,
		},
	},
	avatar: {
		fontSize: tokens.fontSizeBase200,
	},
	listbox: {
		maxHeight: "350px",
	},
	noResultText: {
		margin: "0.25rem auto",
	},
	spinner: {
		margin: tokens.spacingHorizontalM,
	},
	agentSearchContainer: {
		"& > div:first-child": {
			padding: "0",
			width: "100%",
			minWidth: "unset",
			maxWidth: "unset",
		},
	},
});
